// extracted by mini-css-extract-plugin
export default {"mail":"send-email-success_mail__ai04T"};